import React from 'react';
import { Link } from 'react-router-dom';

import { safeGitlabRequestId } from '../api/gitlabRequestId';
import type { GitlabUpdatesFailure } from '../hooks/gitlabUpdatesFailure';
import './GitlabUpdatesNotice.css';

export default function GitlabUpdatesNotice({
  failure,
  onRetry
}: {
  failure: GitlabUpdatesFailure;
  onRetry: () => void;
}) {
  const requestId = safeGitlabRequestId(failure.requestId);
  return (
    <section className="error gitlab-updates-notice" role="alert" aria-label="GitLab updates disconnected">
      <div className="gitlab-updates-notice__content">
        <span>GitLab updates disconnected. {failure.retrying ? 'Reconnecting automatically.' : 'Retry the connection.'}</span>
        <div className="gitlab-updates-notice__actions">
          <button type="button" className="link-button secondary" onClick={onRetry}>Retry now</button>
          {requestId && (
            <Link className="link-button secondary" to={`/logs?request_id=${encodeURIComponent(requestId)}`}>
              View logs
            </Link>
          )}
        </div>
        <details className="gitlab-updates-notice__details">
          <summary>Technical details</summary>
          <dl>
            <div><dt>Request</dt><dd>{failure.request}</dd></div>
            <div><dt>HTTP status</dt><dd>{failure.status === undefined ? 'No HTTP response' : failure.status}</dd></div>
            {requestId && <div><dt>Request ID</dt><dd>{requestId}</dd></div>}
            {failure.contentType && <div><dt>Content type</dt><dd>{failure.contentType}</dd></div>}
            {failure.cloudflare && <>
              <div><dt>Source</dt><dd>{failure.cloudflare.source}</dd></div>
              <div><dt>Cloudflare status</dt><dd>{failure.cloudflare.status}</dd></div>
              {failure.cloudflare.host && <div><dt>Host</dt><dd>{failure.cloudflare.host}</dd></div>}
              {failure.cloudflare.timestamp && <div><dt>Timestamp</dt><dd>{failure.cloudflare.timestamp}</dd></div>}
              {failure.cloudflare.rayId && <div><dt>Cloudflare Ray ID</dt><dd>{failure.cloudflare.rayId}</dd></div>}
              {failure.cloudflare.browserStatus && <div><dt>Browser</dt><dd>{failure.cloudflare.browserStatus}</dd></div>}
              {failure.cloudflare.cloudflareStatus && <div><dt>Cloudflare edge</dt><dd>{failure.cloudflare.cloudflareStatus}</dd></div>}
              {failure.cloudflare.hostStatus && <div><dt>Host status</dt><dd>{failure.cloudflare.hostStatus}</dd></div>}
            </>}
          </dl>
          <div className="gitlab-updates-notice__response">
            <strong>Response details</strong>
            <pre>{failure.detail}</pre>
          </div>
        </details>
      </div>
    </section>
  );
}
